module.exports = __webpack_public_path__ + "img/qr-close.8f0d99da.svg";